const MDX_PATH_RE = /^content\/([a-z]{2})\/([^/]+)\/([^/]+)\.mdx$/;

export function imageFolderForMdx(mdxPath: string): string {
  const m = mdxPath.match(MDX_PATH_RE);
  if (!m) return '';
  const [, locale, category, slug] = m;
  const base = `/images/${category}/${slug}`;
  return locale === 'en' ? base : `${base}/${locale}`;
}

export interface ResolverInput {
  pendingBlobUrls: Map<string, string>;
  mdxPath: string;
  previewOrigin: string;
}

export type ImageResolver = (src: string | undefined) => string;

export function makeImageResolver(input: ResolverInput): ImageResolver {
  const folder = imageFolderForMdx(input.mdxPath);
  return (src) => {
    if (!src) return '';
    // Pending pasted image (in-memory blob).
    const blob = input.pendingBlobUrls.get(src);
    if (blob) return blob;
    // Already absolute? Pass through.
    if (
      src.startsWith('http://') ||
      src.startsWith('https://') ||
      src.startsWith('data:') ||
      src.startsWith('/')
    ) {
      return src;
    }
    // Bare filename — point at the committed location in the preview origin.
    return `${input.previewOrigin}${folder}/${src}`;
  };
}
